import React, { useState } from "react";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";

const QuetionsLanding = () => {
  const [question1, setQuestion1] = useState(false);
  const [question2, setQuestion2] = useState(false);
  const [question3, setQuestion3] = useState(false);
  const setAllFalse = () => {
    setQuestion1(false);
    setQuestion2(false);
    setQuestion3(false);
  };
  return (
    <div className={"questionLandingContainer"}>
      <p>Des Questions?</p>
      <div className="quetionContainer">
        {!question1 ? (
          <button
            onClick={() => {
              setAllFalse();
              setQuestion1(true);
            }}
            className={"questionDetails"}
          >
            <p>Qui peux avoir un compte Easylab ?</p>
            <FontAwesomeIcon icon={faPlusCircle} className={"iconQuetion"} />
          </button>
        ) : (
          <button
            onClick={() => {
              setQuestion1(false);
            }}
            className={"questionDetailsFocused"}
          >
            <div className={"quetionFocusedCountent"}>
              <span>Qui peux avoir un compte Easylab ?</span>
              <FontAwesomeIcon icon={faPlusCircle} className={"iconQuetion"} />
            </div>
            <p>
              Destiné pour tout laboratoire de Prothèse Dentaire qui veux
              s'emparer de la facilité d'uilisation de la plateforme Easylab
              pour organiser ses fiches, ses travaux en cours, les travaux
              sortants et entrants, les paiements, les factures et beaucoup plus
            </p>
          </button>
        )}
        {!question2 ? (
          <button
            onClick={() => {
              setAllFalse();
              setQuestion2(true);
            }}
            className={"questionDetails"}
          >
            <p>Qui peux avoir un compte Easylab ?</p>
            <FontAwesomeIcon icon={faPlusCircle} className={"iconQuetion"} />
          </button>
        ) : (
          <button
            onClick={() => {
              setQuestion2(false);
            }}
            className={"questionDetailsFocused"}
          >
            <div className={"quetionFocusedCountent"}>
              <span>Qui peux avoir un compte Easylab ?</span>
              <FontAwesomeIcon icon={faPlusCircle} className={"iconQuetion"} />
            </div>
            <p>
              Destiné pour tout Médecin Dentiste qui veux professionnaliser la
              relation avec son collaborateur Dental Lab. Avec la plateforme
              Easylab vous pouvez organiser les fiches, les travaux en cours,
              les travaux sortants et entrants, les paiements, les factures et
              beaucoup plus.
            </p>
          </button>
        )}
        {!question3 ? (
          <button
            onClick={() => {
              setAllFalse();
              setQuestion3(true);
            }}
            className={"questionDetails"}
          >
            <p>Pourquoi Easylab a été inventé ?</p>
            <FontAwesomeIcon icon={faPlusCircle} className={"iconQuetion"} />
          </button>
        ) : (
          <button
            onClick={() => {
              setQuestion3(false);
            }}
            className={"questionDetailsFocused"}
          >
            <div className={"quetionFocusedCountent"}>
              <span>Pourquoi Easylab a été inventé ?</span>
              <FontAwesomeIcon icon={faPlusCircle} className={"iconQuetion"} />
            </div>
            <p>
              Dans l'ère digital Transformer votre quotidien par l’innovation et
              Migrer vers le Zero Papier n’est plus un choix. Choisissez Easylab
              et Restez compétitif et surtout gagner du temps précieux.
            </p>
          </button>
        )}
      </div>
    </div>
  );
};

export default QuetionsLanding;
